import { useState } from 'react';
import { isEmpty, isNil } from 'lodash';

import { useQueryUserOrganizations, useSwitchOrg } from '@ion/api';
import { useUserContext } from '@ion/user';
import useAfterOrgSwitch from 'app/after-org-switch';

import filterOrgs from './filterOrgs';
import getOrgName from './getOrgName';

export default function useOrgSwitcher({ orgId }) {
  const afterOrgSwitch = useAfterOrgSwitch();
  const { currentOrg } = useUserContext();
  const { data: orgs, loading: orgsLoading } = useQueryUserOrganizations();
  const [search, setSearch] = useState('');

  const [switchOrg, { loading: switchLoading, data }] = useSwitchOrg({
    onCompleted: data => afterOrgSwitch({ orgId: data.auth0_user_switch_orgs.orgId }),
  });

  const allOrgs = isEmpty(orgs) ? [currentOrg] : orgs;

  return {
    currentOrgName: getOrgName(allOrgs.find(org => org.id === orgId) ?? currentOrg),
    orgs: filterOrgs({ orgs: allOrgs, currentOrgId: orgId, search }),
    loading: orgsLoading,
    search,
    setSearch,
    switchTo: id => switchOrg({ orgId: id }),
    switching: switchLoading || !isNil(data),
  };
}
